import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region redux
import { AppState } from "store";
import { useSelector } from "react-redux";
//#endregion
//#region types
import { IncomingInvoiceSendBackFormContainerProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import IncomingInvoiceSendBackForm from "./sendBackForm";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import * as Yup from "yup";
import { LocalizationHelperInstance } from "utils/helpers";

const IncomingInvoiceSendBackFormContainer: ForwardRefRenderFunction<
  FormHandles,
  IncomingInvoiceSendBackFormContainerProps
> = (props, ref) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const { userName, companyName } = useSelector((state: AppState) => ({
    userName: state.auth.loggedInUser.name.split(" ")[0],
    companyName: state.auth.selectedCompany.name ?? "",
  }));

  const validationSchema = Yup.object<IncomingInvoiceFormTypes.SendBack>({
    email: Yup.string().required(TranslationKeys.Validations.Required).email(TranslationKeys.Validations.InvalidEmail),
    subject: Yup.string().required(TranslationKeys.Validations.Required),
    message: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const defaultValues = {
    email: "",
    subject: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.SendBackDefaultSubject),
    message: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.ForwardMessage, undefined, {
      message: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.SendBackDefaultMessage),
      userName: userName,
      companyName: companyName,
    }),
  } as IncomingInvoiceFormTypes.SendBack;

  const handleSubmit = (values: IncomingInvoiceFormTypes.SendBack) => {
    return incomingInvoiceService.sendBack(props.invoiceId, values.email, values.subject, values.message);
  };

  return (
    <IncomingInvoiceSendBackForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(IncomingInvoiceSendBackFormContainer);
